(() => {
  if (window.__brivarCartPremiumLoaded) return;
  window.__brivarCartPremiumLoaded = true;

  const selector = 'brivar-cart-recommendations';

  const addFromFloatingButton = async (button) => {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const quickPurchase = button.closest('.dm-quick-purchase__base');
    const form = button.closest('[data-quick-purchase-form]');
    const variantInput = form?.querySelector('[data-quick-purchase-variant]');
    const visibleQuantity = form?.querySelector('input[name="quantity"]:not([data-quick-purchase-quantity])');
    const hiddenQuantity = form?.querySelector('[data-quick-purchase-quantity]');

    if (!(quickPurchase instanceof HTMLElement) || !(form instanceof HTMLFormElement) || !(variantInput instanceof HTMLInputElement)) return;

    const productId = String(quickPurchase.dataset.productId || '');
    const mainProductForm = [...document.querySelectorAll('.product-details product-form-component[data-product-id]')]
      .find((component) => component.dataset.productId === productId);
    const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
    const variantId = String(mainVariantInput?.value || variantInput.value || '');
    const quantity = Math.max(1, Number(visibleQuantity?.value || hiddenQuantity?.value || 1));

    if (!variantId) return;

    variantInput.value = variantId;
    if (hiddenQuantity instanceof HTMLInputElement) hiddenQuantity.value = String(quantity);

    const originalMarkup = button.innerHTML;
    const sectionIds = [...new Set(
      [...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map((item) => item.dataset.sectionId)
        .filter(Boolean)
    )];
    const root = window.Shopify?.routes?.root || '/';
    const body = {
      items: [{ id: variantId, quantity }],
      sections_url: window.location.pathname
    };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível adicionar ao carrinho.');

      button.textContent = 'ADICIONADO ✓';
      quickPurchase.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: variantId,
          data: {
            source: 'product-form-component',
            itemCount: quantity,
            productId,
            variantId,
            sections: data.sections
          }
        }
      }));
    } catch (error) {
      console.error('[Brivar] Erro no botão flutuante:', error);
      button.textContent = 'TENTAR NOVAMENTE';
    } finally {
      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.innerHTML = originalMarkup;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1400);
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.dm-quick-purchase__buy');
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addFromFloatingButton(button);
  }, true);

  const reorderProductPayment = () => {
    document.querySelectorAll('.product-details .pix-card').forEach((pix) => {
      const details = pix.closest('.product-details');
      const priceBlock = details?.querySelector('[data-price-pv-block]');
      const payment = details?.querySelector('.payment-method-modal');
      if (priceBlock && payment && (pix.parentElement !== priceBlock || pix.nextElementSibling !== payment)) {
        priceBlock.append(pix, payment);
      }
    });
  };

  const hide = (element) => {
    element.hidden = true;
  };

  const load = async (element) => {
    const list = element.querySelector('[data-upsell-list]');
    const productId = element.dataset.productId;
    if (!list || !productId) return hide(element);

    element.dataset.loaded = 'true';
    element.hidden = false;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}recommendations/products?section_id=brivar-cart-recommendations&product_id=${productId}&limit=2&intent=related`;
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Servidor retornou ${response.status}`);

      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const cards = html.querySelector('[data-brivar-recommendations] .brivar-cart-recommendations__list');
      const persisted = [...list.querySelectorAll('[data-brivar-persisted-upsell]')];
      if (!cards?.children.length && !persisted.length) return hide(element);

      list.innerHTML = cards?.innerHTML || '';
      persisted.reverse().forEach((card) => list.prepend(card));
      while (list.children.length > 2) list.lastElementChild?.remove();
      element.querySelectorAll('.brivar-cart-recommendation-card').forEach((card) => {
        const button = card.querySelector('[data-brivar-toggle-variant]');
        const select = card.querySelector('[data-brivar-variant-select]');
        if (!(button instanceof HTMLButtonElement)) return;
        syncButton(button, select);
        select?.addEventListener('change', () => syncButton(button, select));
        button.addEventListener('click', () => toggle(element, button, select), { once: true });
      });
      const scrollCards = (direction) => {
        const card = list.querySelector('.brivar-cart-recommendation-card');
        const distance = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.82;
        list.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };
      const previous = element.querySelector('[data-brivar-upsell-prev]');
      const next = element.querySelector('[data-brivar-upsell-next]');
      if (previous) previous.onclick = () => scrollCards(-1);
      if (next) next.onclick = () => scrollCards(1);
    } catch (error) {
      console.warn('[Brivar] Recomendações do carrinho indisponíveis:', error);
      hide(element);
    }
  };

  const syncButton = (button, select) => {
    const variantId = select?.value || button.dataset.brivarToggleVariant;
    const cartIds = new Set((button.dataset.cartVariantIds || '').split(',').filter(Boolean));
    const inCart = cartIds.has(String(variantId));
    button.dataset.brivarToggleVariant = String(variantId || '');
    button.dataset.action = inCart ? 'remove' : 'add';
    button.classList.toggle('is-remove', inCart);
    button.textContent = inCart ? 'Retirar' : 'Adicionar';
  };

  const toggle = async (element, button, select) => {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    const variantId = select?.value || button.dataset.brivarToggleVariant;
    const productId = button.dataset.productId;
    const action = button.dataset.action === 'remove' ? 'remove' : 'add';
    const lineKey = button.dataset.cartLineKey;
    if (!variantId) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = action === 'remove' ? 'Retirando…' : 'Adicionando…';

    try {
      const sectionIds = [...new Set(
        [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map((item) => item.dataset.sectionId)
          .filter(Boolean)
      )];
      const common = {
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };
      const endpoint = action === 'remove'
        ? (window.Theme?.routes?.cart_change_url || '/cart/change.js')
        : (window.Theme?.routes?.cart_add_url || '/cart/add.js');
      const body = action === 'remove'
        ? { id: lineKey || Number(variantId), quantity: 0, ...common }
        : {
            items: [{
              id: Number(variantId),
              quantity: 1,
              properties: {
                _brivar_upsell: 'true',
                _brivar_source_product: String(element.dataset.productId || '')
              }
            }],
            ...common
          };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível atualizar.');

      button.textContent = action === 'remove' ? 'Retirado ✓' : 'Adicionado ✓';
      element.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: String(variantId),
          data: {
            source: 'brivar-cart-recommendations',
            itemCount: action === 'remove' ? -1 : 1,
            productId: String(productId || ''),
            sections: data.sections
          }
        }
      }));
    } catch (error) {
      console.error('[Brivar] Erro ao atualizar recomendação:', error);
      button.disabled = false;
      button.textContent = 'Tentar novamente';
      button.title = error.message;
      window.setTimeout(() => {
        if (button.isConnected && !button.disabled) button.textContent = original;
      }, 2500);
    }
  };

  const scan = (force = false) => {
    reorderProductPayment();
    document.querySelectorAll(selector).forEach((element) => {
      if (force) {
        delete element.dataset.loaded;
        const list = element.querySelector('[data-upsell-list]');
        if (list) list.replaceChildren();
      }
      if (element.dataset.loaded !== 'true') load(element);
    });
  };

  const start = () => {
    scan();
    const observer = new MutationObserver(() => scan());
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:update', () => window.setTimeout(() => scan(true), 500));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
